// ========= REAL PROJECT IMAGES (these files must exist in src/assets/) =========
import RagImg from '../../assets/rag.png';
import EtlImg from '../../assets/etl.png';
import MlopsImg from '../../assets/cicd.png';
import MlflowImg from '../../assets/mlflow.png';

// ========= PLACEHOLDERS (you don't have these images yet) =========
const DeepfakeImg =
	'https://www.stephens-scown.co.uk/app/uploads/2024/04/GettyImages-1286627625-1024x576.jpg';
const MonkeypoxImg =
	'https://assets.clevelandclinic.org/transform/LargeFeatureImage/2ea0cbbf-6d41-4502-ad5d-2af9a75dd949/monkeypox-Virus-1405093360-770x533-1_jpg';

// ========= PROJECTS =========
export const projectsData = [
	{
		id: 1,
		image: RagImg,
		title: 'AI Document Q&A (RAG)',
		category: 'GenAI',
		description:
			'Retrieval-Augmented Generation system for document Q&A using embeddings, vector retrieval (Top-K), and grounded responses.',
		techStack: ['Python', 'LangChain', 'RAG', 'NLP'],
		githubLink: 'https://github.com/vamsireddy99126/ai-document-qa-rag',
		liveLink: 'https://github.com/vamsireddy99126/ai-document-qa-rag'
	},
	{
		id: 2,
		image: EtlImg,
		title: 'Azure CoinGecko ETL Pipeline',
		category: 'Data',
		description:
			'Automated ETL pipeline extracting CoinGecko API data, transforming market snapshots, and loading into Azure SQL (fact/dim tables).',
		techStack: ['Python', 'ETL', 'APIs', 'Azure'],
		githubLink: 'https://github.com/vamsireddy99126/azure-coingecko-etl',
		liveLink: 'https://github.com/vamsireddy99126/azure-coingecko-etl'
	},

	// ✅ CI/CD (separate card) — uses same mlops.png image so no extra file needed
	{
		id: 3,
		image: MlopsImg,
		title: 'CI/CD Automation (GitHub Actions)',
		category: 'MLOps',
		description:
			'CI pipeline enabled with GitHub Actions to validate code on push/PR and automate checks for an ML project workflow.',
		techStack: ['GitHub Actions', 'CI/CD', 'Python'],
		githubLink: 'https://github.com/vamsireddy99126/mlops-ci-cd-project',
		liveLink: 'https://github.com/vamsireddy99126/mlops-ci-cd-project'
	},
	{
		id: 4,
		image: MlopsImg,
		title: 'MLOps CI/CD Project',
		category: 'MLOps',
		description:
			'End-to-end MLOps workflow demonstrating reproducible training and automation with CI/CD best practices.',
		techStack: ['Python', 'CI/CD', 'GitHub Actions', 'Docker'],
		githubLink: 'https://github.com/vamsireddy99126/mlops-ci-cd-project',
		liveLink: 'https://github.com/vamsireddy99126/mlops-ci-cd-project'
	},
	{
		id: 5,
		image: MlflowImg,
		title: 'MLflow Experiment Tracking (Heart Disease)',
		category: 'MLOps',
		description:
			'Experiment tracking and model comparison using MLflow. Logged parameters, metrics (accuracy), and model artifacts (SQLite backend).',
		techStack: ['Python', 'MLflow', 'scikit-learn', 'Experiment Tracking'],
		githubLink: 'https://github.com/vamsireddy99126/heart-mlflow-project',
		liveLink: 'https://github.com/vamsireddy99126/heart-mlflow-project'
	},
	{
		id: 6,
		image: DeepfakeImg,
		title: 'Deepfake Image Detection',
		category: 'Computer Vision',
		description:
			'Computer vision project for detecting deepfake images with model training and evaluation workflow.',
		techStack: ['Python', 'Deep Learning', 'Computer Vision'],
		githubLink: 'https://github.com/vamsireddy99126/deepfake-image-detection',
		liveLink: 'https://github.com/vamsireddy99126/deepfake-image-detection'
	},
	{
		id: 7,
		image: MonkeypoxImg,
		title: 'Monkeypox Prediction (ML)',
		category: 'Machine Learning',
		description:
			'Machine learning project for Monkeypox prediction including preprocessing, training, and performance evaluation.',
		techStack: ['Python', 'Machine Learning', 'Data Preprocessing', 'Metrics'],
		githubLink:
			'https://github.com/vamsireddy99126/monkeypox-prediction-in-machine-learning',
		liveLink: 'https://github.com/vamsireddy99126/monkeypox-prediction-in-machine-learning'
	}
];

// ========= FILTER TABS =========
export const projectsNav = [
	{ name: 'all' },
	{ name: 'GenAI' },
	{ name: 'MLOps' },
	{ name: 'Data' },
	{ name: 'Computer Vision' },
	{ name: 'Machine Learning' }
];
